export default __webpack_public_path__ + "static/media/201.ba908a74.png";